import { Location, Price, Venue } from "sweet-global";

export const SEARCH_FOCUS = "search/SEARCH_FOCUS";
export const SEARCH_FILTER = "search/SEARCH_FILTER";
export const SEARCH_INIT = "search/SEARCH_INIT";
export const SEARCH_SUCCESS = "search/SEARCH_SUCCESS";
export const SEARCH_FAILURE = "search/SEARCH_FAILURE";
export const RESET_SEARCH = "search/RESET_SEARCH";

export interface Filters {
  guests?: number;
  date?: string;
  budget?: number;
  eventType?: string;
  venueType?: string[];
}

export interface SearchState {
  query: string;
  location: Location;
  results: Venue[];
  isSearching: boolean;
  successSearching: boolean;
  errorSearching: Error | null;
  filters: Filters;
  focused: boolean;
}

interface ResetSearchAction {
  type: typeof RESET_SEARCH;
}

interface SearchFocusAction {
  type: typeof SEARCH_FOCUS;
  focus: boolean;
}
interface SearchFilterAction {
  type: typeof SEARCH_FILTER;
  filter: Partial<Filters>;
}

interface SearchInitAction {
  type: typeof SEARCH_INIT;
  query: string;
}

interface SearchSuccessAction {
  type: typeof SEARCH_SUCCESS;
  results: Venue[];
}

interface SearchFailureAction {
  type: typeof SEARCH_FAILURE;
  error: Error;
}

export type SearchActionTypes =
  | ResetSearchAction
  | SearchFocusAction
  | SearchInitAction
  | SearchSuccessAction
  | SearchFailureAction
  | SearchFilterAction;
